import React from "react"
import {RedocStandalone} from 'redoc'
import {Grid, ThemeProvider, Box, GlobalStyles} from "@mui/material"
import {AppBar} from '@mui/material'
import theme from "../../utils/theme"

const ApiPublicPage = () => {

    return <ThemeProvider theme={theme}>
        <GlobalStyles styles={{
            body: {margin: 0, padding: 0},
            '#redoc, .redoc-wrap': {margin: 0},
        }}/>
        <AppBar position="fixed" sx={{p: 1.5}}>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                    <img src="/logo/c2p-logo.webp" alt="C2P" style={{height: 28}}/>
                </Grid>
            </Grid>
        </AppBar>

        <Box
            sx={{
                mt: {xs: '52px', sm: '52px'},
                position: 'relative',
                zIndex: 0,
                '& .menu-content': {
                    position: 'sticky',
                    top: {xs: '56px', sm: '64px'},
                },
                '& .api-content': {
                    paddingTop: {xs: '56px', sm: '64px'},
                },
            }}
        >
            <RedocStandalone
                specUrl={`./public-api-doc.json`}
                options={{
                    nativeScrollbars: true,
                    scrollYOffset: '.MuiAppBar-root',
                    theme: {colors: {primary: {main: '#dd5522'}}},
                }}
            />
        </Box>
    </ThemeProvider>
}

export default ApiPublicPage